/**
 * Created by Johan Schram - KOSMEO ANALITICS - https://kosmeo-a.com on 16/05/2017.
 */

const config = {
    version : {
        v : '0.1',
        date : '16/05/2017'
    },
    server: {
        url : 'https://wtmserve.kosmeo-a.com',
        otp : 'https://otp.kosmeo-a.com',
        // url : 'http://localhost:3102',
        // otp : 'http://167.114.246.32/serve'
        // url : 'http://167.114.246.32/serve'
        ban : 'https://api-adresse.data.gouv.fr/search',
        banReverse : 'https://api-adresse.data.gouv.fr/reverse'
    }
};

export default config;





// WEBPACK FOOTER //
// ./src/services/config.js